<template>
    <div>
      <br />

      <el-tabs type="border-card">
         <el-tab-pane lazy>
           <span slot="label"><i class="fa fa-tasks">&nbsp;</i>Active <el-badge v-if="numActive" type="primary" :value="numActive"/></span>
           <actions-table type="Active" :row-data="rowData" :edit-mode="editMode" :read-only="readOnly" />
         </el-tab-pane>

         <el-tab-pane lazy>
           <span slot="label"><i class="fa fa-exclamation-triangle">&nbsp;</i>Rejected <el-badge v-if="numRejects" type="warning" :value="numRejects"/></span>
           <actions-table type="Rejected" :row-data="rowData" :edit-mode="false" />
         </el-tab-pane>

         <el-tab-pane lazy>
           <span slot="label"><i class="fa fa-flag">&nbsp;</i>Closed <el-badge v-if="numClosed" type="success" :value="numClosed"/></span>
           <actions-table type="Closed" :row-data="rowData" :edit-mode="false" :read-only="readOnly" />
         </el-tab-pane>

      </el-tabs>
      <br />
  </div>
</template>

<script>

import ActionsTable from '@/components/actions/ActionsTable'

export default {

  components: {
    ActionsTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  computed: {
    numActive: function () {

      if (this.stats) {
        return Number(this.stats.requests) + Number(this.stats.prg)
      }

      return null
    },

    numRejects: function () {
      if (this.stats) {
        return Number(this.stats.rtsRejected) + Number(this.stats.rtuRejected) + Number(this.stats.rtbRejected) + Number(this.stats.rtdRejected)
      }

      return null
    },

    numClosed: function () {
      if (this.stats) {
        return Number(this.stats.rtsClosed) + Number(this.stats.rtuClosed) + Number(this.stats.rtbClosed) + Number(this.stats.rtdClosed)
      }

      return null
    }
  },

  data () {
    return {
      stats: this.rowData && this.rowData.stats ? this.rowData.stats : null
    }
  }


}

</script>



// WEBPACK FOOTER //
// SiteActions.vue?09503267